import { createContext } from 'react'

export const Page = createContext({
  currentPageName: 'dashboard',
})
